// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"1cad9065","856":"c41002e8"}[chunkId] + ".js";
};